import { IconChevronDown } from '@tabler/icons-react';
import { ActionIcon, Group, Image } from '@mantine/core';
import { ChatConversationHeader } from '@/src/shared/components/chat/chat-conversation-header';
import { useMarketplaceCustomerChatContext } from '../../../_contexts';

interface IChatFloatingWindowConversationHeaderProps {
  onClose?: () => void;
}

export function ChatFloatingWindowConversationHeader({
  onClose,
}: IChatFloatingWindowConversationHeaderProps) {
  const {
    selectedConversation,
    selfMedicationConversation,
    complaintConversation,
  } = useMarketplaceCustomerChatContext();
  const selfMedicationConversationIsSelected =
    selectedConversation?.props.id === selfMedicationConversation?.props.id;
  const complaintConversationIsSelected =
    selectedConversation?.props.id === complaintConversation?.props.id;

  const getOverrideName = () => {
    if (selfMedicationConversationIsSelected) {
      return 'Chat Swamedikasi';
    }
    if (complaintConversationIsSelected) {
      return 'Chat Pengaduan';
    }
    return undefined;
  };

  const getAvatarSrc = () => {
    if (selfMedicationConversationIsSelected) {
      return '/images/pharmacy.jpg';
    }
    if (complaintConversationIsSelected) {
      return '/images/customer-service.png';
    }
  };

  const getAvatar = () => {
    if (
      !selfMedicationConversationIsSelected &&
      !complaintConversationIsSelected
    ) {
      return null;
    }
    return (
      <Image
        w="2.2rem"
        h="2.2rem"
        src={getAvatarSrc()}
        alt={getOverrideName()}
        className="object-contain!"
        bg="white"
        bdrs={999}
      />
    );
  };

  return (
    <ChatConversationHeader
      size="sm"
      conversation={selectedConversation}
      overrideName={getOverrideName()}
      actions={
        <Group>
          <ActionIcon size="sm" variant="transparent" onClick={onClose}>
            <IconChevronDown color="black" />
          </ActionIcon>
        </Group>
      }
      avatar={getAvatar()}
      withBackButton={false}
    />
  );
}
